module.exports = __webpack_public_path__ + "img/202311_01.f12f2833.jpg";